
const state = {};
const getters={
	count:state => {
		return state.count
	}
}
const mutations = {
	increment(state) {
		state.count++
	},
	decrement(state) {
			state.count--
	}
}
export default {
	state,mutations,getters
}



// WEBPACK FOOTER //
// ./src/vuex/global/index.js